import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-cookies-notice',
  templateUrl: './cookies-notice.component.html',
  styleUrls: ['./cookies-notice.component.scss'],
})
export class CookiesNoticeComponent implements OnInit {
  // language: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    // this.route.params.forEach((params: Params) => {
    //   this.language = params['language'];
    // });
  }
}
